import React from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import BarChartIcon from '@mui/icons-material/BarChart';
import HistoryIcon from '@mui/icons-material/History';
import SettingsIcon from '@mui/icons-material/Settings';
import ScoreboardIcon from '@mui/icons-material/Scoreboard';
import { Option } from '@components/SideBar/interfaces';
import { PERMISSIONS } from '@auth/permissions';

export const competitionMenuOptions: Option[] = [
  {
    key: 'overview',
    link: '/manage/competitions/overview',
    icon: <VisibilityIcon />,
    permission: PERMISSIONS.competitions.view,
    inProduction: true,
  },
  {
    key: 'disciplines',
    link: '/manage/competitions/disciplines/overview',
    icon: <GpsFixedIcon />,
    permission: PERMISSIONS.competitions.disciplines.view,
    inProduction: true,
  },
  {
    key: 'scores',
    link: '/manage/competitions/scores',
    icon: <ScoreboardIcon />,
  },
  {
    key: 'stats',
    link: '/manage/competitions/stats',
    icon: <BarChartIcon />,
  },
  {
    key: 'activityLog',
    link: '/manage/competitions/activity-log',
    icon: <HistoryIcon />,
  },
  {
    key: 'settings',
    link: '/manage/competitions/settings',
    icon: <SettingsIcon />,
  },
];
